import { Breakpoints } from "../../typeHelpers";
import { useState, useEffect } from "react";
export const useCurrentBreakpoint = () => {
    const [currentBreakpoint, setCurrentBreakpoint] = useState("mobile");
    useEffect(() => {
        const updateBreakpoint = () => {
            if (window.innerWidth >= Breakpoints.desktop)
                setCurrentBreakpoint("desktop");
            else if (window.innerWidth >= Breakpoints.tablet)
                setCurrentBreakpoint("tablet");
            else
                setCurrentBreakpoint("mobile");
        };
        updateBreakpoint();
        window.addEventListener("resize", updateBreakpoint);
        return () => {
            window.removeEventListener("resize", updateBreakpoint);
        };
    }, []);
    return currentBreakpoint;
};
